import type { ConvexClient } from "convex/browser";
import { useSyncExternalStore } from "react";

// The window's own live client to the World, signed in as the person with the window's Clerk session (Can 31,
// WorldClerkSession.tsx). It is published here once the World has accepted the sign-in, so the Desk's screens that read
// the person's conversations kept in the World (Can 23: the ones Pocket starts among them) use the same doors Pocket
// uses, as the same person, with no second sign-in. Null while there is none (signed out, or a build without Clerk).

let current: ConvexClient | null = null;
const listeners = new Set<() => void>();

export function publishWorldConvexClient(client: ConvexClient | null): void {
  if (current === client) return;
  current = client;
  for (const listener of listeners) listener();
}

export function readWorldConvexClient(): ConvexClient | null {
  return current;
}

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** The window's signed-in World client, or null. */
export function useWorldConvexClient(): ConvexClient | null {
  return useSyncExternalStore(subscribe, readWorldConvexClient, () => null);
}
